import { useNavigate } from 'react-router-dom';

import { ForgotPasswordForm } from './ForgotPasswordForm';

export function ForgotPasswordBody() {
    const navigate = useNavigate();

    return (
        <div className='flex flex-col items-center'>
            <h1 className="text-2xl font-medium mb-5">Forgot Password</h1>
            <ForgotPasswordForm />
            <span className='block mt-4 text-sm font-light'>
                Already have account?
                <button onClick={() => navigate('/login')} className='ms-1 font-semibold text-red-700 underline cursor-pointer'>Login</button>
            </span>
            <span className='block mt-4 text-sm font-light'>
                Create your Seller <b className='font-semibold'>Artist / Gallery</b> account
                <button onClick={() => navigate('/register')} className='ms-1 font-semibold text-red-700 underline cursor-pointer'>Register Now</button>
            </span>
        </div>
    );
}
